<script>
export default {
	lang: 'books',
	inject: ['editor'],
	props: ['dataKey', 'title', 'options'],
	computed: {
		e() {
			return this.editor()
		},
	},
	mounted() {
		this.$assignDefaults(this.e.customization.data, { [this.dataKey]: null })
	},
}
</script>

<template>
	<div>
		<div>{{ title }}</div>
		<div>
			<v-item-group
				v-model="e.customization.data[dataKey]"
				:mandatory="!!e.customization.data[dataKey]"
				class="d-flex align-center justify-center flex-wrap flex-md-nowrap"
				style="gap: 12px"
			>
				<v-item
					v-slot="{ active, toggle }"
					:value="value"
					v-for="{ value, label, img } of options"
					:key="value"
				>
					<div class="images-options-selector" :class="{ active }" @click="toggle">
						<div class="images-options-selector__icon">
							<Media :src="img" max-width="80" max-height="80" eager />
						</div>
						<div class="images-options-selector__label">
							{{ label }}
						</div>
					</div>
				</v-item>
			</v-item-group>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.images-options-selector {
	cursor: pointer;
	padding: 4px;
	opacity: 0.7;
	transition: all 0.3s;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.images-options-selector__icon {
		width: 96px;
		height: 96px;
		transition: all 0.3s;
		border: 4px solid transparent;
		border-radius: 100%;
		padding: 4px;
		overflow: hidden;
	}
	&:not(.active):hover {
		opacity: 0.8;
		.images-options-selector__icon {
			border: 4px solid var(--v-blue-lighten3);
		}
	}
	&.active {
		opacity: 1;
		.images-options-selector__icon {
			border: 4px solid var(--v-blue-base);
		}
	}
	.images-options-selector__label {
		padding-top: 4px;
		font-weight: bold;
	}
}
</style>
